import { Directive, ElementRef } from '@angular/core';

/** Infinite scroll item marker */
@Directive({
  selector: '[atxInfiniteScrollItem]',
  standalone: false,
})
export class InfiniteScrollItemDirective {
  constructor(public host: ElementRef) {}
}
